var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-move-to-cart.j2"] = require( "product-move-to-cart.j2" );
dependencies["quickshop-actions/quickshop-owner-actions.j2"] = require( "quickshop-actions/quickshop-owner-actions.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-actions/quickshop-owner-actions-outer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showMoveToCart")) {
output += "\n\n\t<div class=\"o-row\">\n\n\t\t<div class=\"o-column o-extra-small--12 c-product-move-to-cart\">\n\n\t    \t";
env.getTemplate("product-move-to-cart.j2", false, "product/templates/quickshop-actions/quickshop-owner-actions-outer.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n\t\t</div>\n\n\t</div>\n\n";
})});
}
output += "\n\n";
env.getTemplate("quickshop-actions/quickshop-owner-actions.j2", false, "product/templates/quickshop-actions/quickshop-owner-actions-outer.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-actions/quickshop-owner-actions-outer.j2"] , dependencies)